import type { DocumentData } from "firebase/firestore";
import { compactData, dateValue, stringList, stringValue } from "./firestore";
import type { SBotCatalogSource, SBotReviewStatus } from "./catalog";

// Mirrors firestore.rules validOrganizationShape / Models/OrganizationModel.swift.

export interface OrganizationModel {
  id: string;
  sportID: string;
  leagueID: string;
  name: string;
  abbreviation?: string;
  location?: string;
  primaryColorHex?: string;
  secondaryColorHex?: string;
  logoURL?: string;
  source: SBotCatalogSource;
  reviewStatus: SBotReviewStatus;
  createdByUserID?: string;
  adminUserIDs: string[];
  managerUserIDs: string[];
  staffUserIDs: string[];
  coachUserIDs: string[];
  athleteUserIDs: string[];
  espnTeamID?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export function parseOrganization(id: string, data: DocumentData): OrganizationModel | null {
  const sportID = stringValue(data.sportID);
  const leagueID = stringValue(data.leagueID);
  const name = stringValue(data.name);
  if (!sportID || !leagueID || !name) return null;
  return {
    id,
    sportID,
    leagueID,
    name,
    abbreviation: stringValue(data.abbreviation),
    location: stringValue(data.location),
    primaryColorHex: stringValue(data.primaryColorHex),
    secondaryColorHex: stringValue(data.secondaryColorHex),
    logoURL: stringValue(data.logoURL),
    source: data.source === "espn" ? "espn" : "custom",
    reviewStatus: data.reviewStatus === "approved" || data.reviewStatus === "rejected" ? data.reviewStatus : "pendingReview",
    createdByUserID: stringValue(data.createdByUserID),
    adminUserIDs: stringList(data.adminUserIDs),
    managerUserIDs: stringList(data.managerUserIDs),
    staffUserIDs: stringList(data.staffUserIDs),
    coachUserIDs: stringList(data.coachUserIDs),
    athleteUserIDs: stringList(data.athleteUserIDs),
    espnTeamID: stringValue(data.espnTeamID),
    createdAt: dateValue(data.createdAt),
    updatedAt: dateValue(data.updatedAt),
  };
}

export function organizationFirestoreData(organization: OrganizationModel): Record<string, unknown> {
  return compactData({
    id: organization.id,
    sportID: organization.sportID,
    leagueID: organization.leagueID,
    name: organization.name,
    abbreviation: organization.abbreviation,
    location: organization.location,
    primaryColorHex: organization.primaryColorHex,
    secondaryColorHex: organization.secondaryColorHex,
    logoURL: organization.logoURL,
    source: organization.source,
    reviewStatus: organization.reviewStatus,
    createdByUserID: organization.createdByUserID,
    adminUserIDs: organization.adminUserIDs,
    managerUserIDs: organization.managerUserIDs,
    staffUserIDs: organization.staffUserIDs,
    coachUserIDs: organization.coachUserIDs,
    athleteUserIDs: organization.athleteUserIDs,
    espnTeamID: organization.espnTeamID,
    createdAt: organization.createdAt,
    updatedAt: organization.updatedAt,
  });
}
